var map = {
	"./404.svg": "sEM+",
	"./Edition-t.svg": "3vA4",
	"./Nursery-t.svg": "leQG",
	"./System-t.svg": "X5Tf",
	"./add.svg": "58n+",
	"./bell.svg": "AFe0",
	"./clipboard.svg": "KO/S",
	"./code.svg": "IX5Q",
	"./delete.svg": "Imjp",
	"./dis.svg": "S01t",
	"./discuss.svg": "fIiT",
	"./doctor.svg": "mJe2",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./forum-t.svg": "ozDD",
	"./hospital.svg": "qfL7",
	"./jine.svg": "rZ2c",
	"./kapian.svg": "xCpP",
	"./message.svg": "G2zY",
	"./money.svg": "ig9B",
	"./order-t.svg": "0aef",
	"./page-t.svg": "5F7c",
	"./password.svg": "QjmH",
	"./phone.svg": "7pRf",
	"./position.svg": "3sTt",
	"./power.svg": "aUH0",
	"./shuliang.svg": "vUSo",
	"./street.svg": "S2Qx",
	"./user-t.svg": "unNb",
	"./user.svg": "VdD3",
	"./warehouse.svg": "BupX",
	"./youhuiquan.svg": "Wu/B",
	"./zan.svg": "M++c"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 50